import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "../../components/controls/Button";
import SuccessImg from "../../images/AnanasSolutionsLogo.webp";

export default function CheckoutSubscriptionSuccessPage() {
  const [searchParams] = useSearchParams();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const sessionId = searchParams.get("session_id");

  useEffect(() => {
    const lang = searchParams.get("lang") || "fr";
    i18n.changeLanguage(lang);
  }, [searchParams]);

  return (
    <main className="min-h-screen flex flex-col items-center justify-center p-6 bg-gradient-to-b from-[#fff8e8] to-white">
      <section className="w-full max-w-lg text-center">
        {/* Image + halo */}
        <div className="relative mx-auto w-48 sm:w-44 aspect-square">
          <div className="absolute inset-0 rounded-full bg-[#ffefc2] blur-3xl opacity-60" />
          <img
            src={SuccessImg}
            alt={t("subscriptionSuccess.logoAlt", "Logo Ananas Solutions")}
            className="relative z-10 w-full h-full object-contain drop-shadow-md"
          />
        </div>

        {/* Titre premium */}
        <h1 className="mt-8 text-3xl font-semibold text-[#2f5130]">
          {t("subscriptionSuccess.thank_you", "Merci pour votre abonnement !")}
        </h1>

        {/* Texte chaleureux */}
        <p className="mt-4 text-base leading-relaxed text-[#6b705c]">
          {t(
            "subscriptionSuccess.subscription_confirmed",
            "Votre abonnement a été confirmé avec succès."
          )}
        </p>

        <p className="mt-2 text-sm text-[#8a8f89]">
          {t(
            "subscriptionSuccess.support_text",
            "Merci de faire rayonner les entreprises locales."
          )}
        </p>

        {/* Session ID si présent */}
        {sessionId && (
          <p className="mt-4 text-xs opacity-70 font-mono text-[#6b705c]">
            ID: {sessionId}
          </p>
        )}

        {/* Bouton Retour */}
        <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            size="lg"
            fullWidth
            onClick={() =>
              navigate(`/?lang=${searchParams.get("lang") || "fr"}`)
            }
            className="sm:w-auto shadow-md hover:shadow-lg transition-all"
          >
            {t("subscriptionSuccess.back_home", "Retour à l'accueil")}
          </Button>
        </div>
      </section>
    </main>
  );
}
